import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import Quill from 'quill';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping } from 'shared-library';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit {
  navOptions = ['Home'];
  customer = "";
  app = "";
  defaultAppInfo:boolean = true;
  policyFetched:boolean = true;
  policy:any = "";
  safePolicy!: SafeHtml;
  logo:string = "assets/imgs/nuhospitsls.png"
  imageUrl:string = "";
  constructor(
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private dataService: VlDataService,
    private httpService: VlHttpService, 
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.customer = this.activatedRoute.snapshot.paramMap.get('customer') ?? '';
    this.app = this.activatedRoute.snapshot.paramMap.get('app') ?? ''
    if(this.customer === 'nuhospitals' ){
      this.imageUrl = this.logo
    }else{
      this.getPolicy();
    }
  }

  navigateTo(route: any[]) {
    this.route.navigate(route);
  }

  getPolicy(){
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_POLICY_BY_APPLICATIONID']);
        apiConfig.postData = {
          applicationId:this.customer,
        }
    
        this.httpService.placeAPICall(apiConfig).subscribe({
          next: (data: any) => {
            this.policy = this.fixLinks(data?.content);
            this.safePolicy = this.sanitizer.bypassSecurityTrustHtml(this.fixLinks(data?.content));
            this.imageUrl = data?.logo;
            this.addpolicy()
          },
          error: (err: any) => {
            this.policyFetched = false;
            this.imageUrl = '';
          }
        })
      }

    // Method to fix link URLs
    fixLinks(content: string): string {
      return content.replace(
        /href="((?:http:\/\/)?localhost:\d+\/)?([^"]+)"/g, 
        (match, prefix, url) => {
          const fullUrl = url.startsWith('http') 
            ? url 
            : `https://${url}`;
          return `href="${fullUrl}" target="_blank" rel="noopener noreferrer"`;
        }
      );
    }

  addpolicy(){
    // Create a read-only Quill instance for viewing content
    const viewerElement = document.getElementById('policy-viewer');
    if(viewerElement){

      const viewerQuill = new Quill(viewerElement, {
        readOnly: true,
        modules: {
          toolbar: false
        },
        theme: 'snow'
      });
      // Set the content from your policy data
      viewerQuill.clipboard.dangerouslyPasteHTML(this.policy);
    }
  
  }
}
